var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3336 2.86102e-06H2.66691C1.20024 2.86102e-06 0.000244141 1.2 0.000244141 2.66667V21.3333C0.000244141 22.8 1.20024 24 2.66691 24H21.3336C22.8002 24 24.0002 22.8 24.0002 21.3333V2.66667C24.0002 1.2 22.8002 2.86102e-06 21.3336 2.86102e-06ZM9.33358 18.6667L2.66691 12L4.53358 10.1333L9.33358 14.9333L19.4669 4.80001L21.3336 6.66668L9.33358 18.6667Z",
    fill: "#107DEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.de605b93379e6951e5f1c3b61bcbed00.svg";
export { ForwardRef as ReactComponent };